module.exports = __webpack_public_path__ + "static/media/slideshow-32.92e547c6.jpeg";